import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "valueChange", "onChange", "placeholder", "rangePresets", "label", "defaultValue", "error", "errMessage", "containerId"],
    _excluded2 = ["name", "control", "rules", "defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Box, FormHelperText } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from 'antd';
import clsx from 'clsx';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { useController } from 'react-hook-form';
import { getLocalTranslation } from '../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var defaultRangePresets = [{
  label: 'Last 7 Days',
  value: [dayjs().add(-7, 'd'), dayjs()]
}, {
  label: 'Last 14 Days',
  value: [dayjs().add(-14, 'd'), dayjs()]
}, {
  label: 'Last 30 Days',
  value: [dayjs().add(-30, 'd'), dayjs()]
}, {
  label: 'Last 90 Days',
  value: [dayjs().add(-90, 'd'), dayjs()]
}];
var JoveDateRangePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      valueChange = props.valueChange,
      onChange = props.onChange,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? [getLocalTranslation().$t('common:start_date'), getLocalTranslation().$t('common:end_date')] : _props$placeholder,
      _props$rangePresets = props.rangePresets,
      rangePresets = _props$rangePresets === void 0 ? defaultRangePresets : _props$rangePresets,
      label = props.label,
      defaultValue = props.defaultValue,
      error = props.error,
      errMessage = props.errMessage,
      containerId = props.containerId,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue),
      selectDates = _useState[0],
      setSelectDates = _useState[1];

  var dateChangeAction = function dateChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    setSelectDates(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(LocalizationProvider, {
    dateAdapter: AdapterDayjs,
    adapterLocale: "en-gb",
    children: /*#__PURE__*/_jsxs(Box, {
      className: clsx('flex w-full flex-col', className),
      children: [label && /*#__PURE__*/_jsx("span", {
        className: "text-black-secondary text-sm font-medium",
        children: label
      }), /*#__PURE__*/_jsx(RangePicker, _objectSpread(_objectSpread({}, rest), {}, {
        presets: rangePresets,
        value: value === undefined ? selectDates : value,
        defaultValue: defaultValue,
        onChange: dateChangeAction,
        placeholder: placeholder,
        getPopupContainer: containerId ? function () {
          return document.getElementById(containerId);
        } : null
      })), error && /*#__PURE__*/_jsx(FormHelperText, {
        error: error,
        children: errMessage
      })]
    })
  });
});
export var JoveDateRangePickerControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsx(JoveDateRangePicker, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      onChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveDateRangePicker;